/**
 * Rivaro — Reveal-on-scroll
 * IntersectionObserver-based reveal con stagger automático para grids.
 * Targets:
 *   - Cualquier elemento con [data-rivaro-reveal]
 *   - Auto-target: secciones del homepage, headings h1/h2/h3, product cards
 *
 * Excluido automáticamente:
 *   - .header-wrapper, [class*="header-sections"]
 *   - .rivaro-hero (ya tiene su propia animación)
 *   - .rivaro-loader
 *   - footer, [class*="announcement-bar"]
 */
(function () {
  if (typeof IntersectionObserver === 'undefined') return;

  var REVEAL_ATTR = 'data-rivaro-reveal';
  var REVEALED_CLASS = 'is-revealed';
  var STAGGER_MS = 80;
  var GRID_THRESHOLD = 60; // px — items con top similar se consideran del mismo "row" para stagger

  var observer = new IntersectionObserver(
    function (entries, obs) {
      // Agrupar entries que entran en viewport por "fila" para aplicar stagger
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.rivaroRevealDelay || '0', 10);
        if (delay > 0) el.style.setProperty('--rivaro-reveal-delay', delay + 'ms');
        // Activar reveal en el siguiente paint para forzar transition
        requestAnimationFrame(function () {
          el.classList.add(REVEALED_CLASS);
        });
        obs.unobserve(el);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  function shouldExclude(el) {
    return (
      el.closest('.header-wrapper') ||
      el.closest('[class*="header-sections--"]') ||
      el.closest('.rivaro-hero') ||
      el.closest('.rivaro-loader') ||
      el.closest('footer') ||
      el.closest('[class*="announcement-bar"]') ||
      el.closest('[class*="shopify-section-header"]')
    );
  }

  function applyStaggerToGrid(elements) {
    // Agrupar por su top relativo y aplicar delay incremental por fila
    var rows = {};
    elements.forEach(function (el) {
      var top = Math.floor(el.getBoundingClientRect().top / GRID_THRESHOLD);
      if (!rows[top]) rows[top] = [];
      rows[top].push(el);
    });
    Object.values(rows).forEach(function (rowItems) {
      rowItems.forEach(function (el, idx) {
        if (!el.dataset.rivaroRevealDelay) {
          el.dataset.rivaroRevealDelay = (idx * STAGGER_MS).toString();
        }
      });
    });
  }

  function autoTargetCommonElements() {
    // Secciones del cuerpo (excepto las excluidas)
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (sec) {
      if (shouldExclude(sec)) return;
      if (sec.hasAttribute(REVEAL_ATTR)) return;
      sec.setAttribute(REVEAL_ATTR, '');
    });

    // Product cards adentro de las secciones
    var productCards = document.querySelectorAll(
      'main .product-card, main [class*="card-product"], main [class*="card-wrapper"]'
    );
    if (productCards.length) {
      var cards = Array.from(productCards).filter(function (c) {
        return !shouldExclude(c) && !c.hasAttribute(REVEAL_ATTR);
      });
      cards.forEach(function (c) { c.setAttribute(REVEAL_ATTR, ''); });
      applyStaggerToGrid(cards);
    }
  }

  function init() {
    autoTargetCommonElements();
    var elements = document.querySelectorAll('[' + REVEAL_ATTR + ']');
    elements.forEach(function (el) {
      // Si ya está visible al cargar (above-the-fold), revelarlo de una sin observer
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
        el.classList.add(REVEALED_CLASS);
        return;
      }
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
